import { Link } from "react-router-dom";
import type { Run } from "../../lib/types.js";
import styles from "./RunTimeline.module.css";

interface RunTimelineProps {
  runs: Run[];
  onLoadMore?: () => void;
  hasMore?: boolean;
}

function formatDate(str: string): string {
  return new Date(str).toLocaleString();
}

function formatDuration(ms?: number): string {
  if (!ms) return "—";
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.floor(ms / 60000)}m ${Math.floor((ms % 60000) / 1000)}s`;
}

export function RunTimeline({ runs, onLoadMore, hasMore }: RunTimelineProps) {
  return (
    <div className={styles.timeline}>
      {runs.map((run) => (
        <Link to={`/runs/${run.id}`} key={run.id} className={styles.entry}>
          <div className={styles.dot} data-status={run.status} />
          <div className={styles.body}>
            <div className={styles.top}>
              <span className={styles.time}>{formatDate(run.startedAt)}</span>
              <span className={`${styles.badge} ${styles[run.status]}`}>{run.status}</span>
              {run.rerunMode && (
                <span className={styles.rerunTag}>↩ {run.rerunMode}</span>
              )}
            </div>
            {run.summary && (
              <div className={styles.stats}>
                <span className={styles.score}>{run.summary.score}%</span>
                <span className={styles.pass}>✓ {run.summary.passed}</span>
                <span className={styles.fail}>✗ {run.summary.failed}</span>
                {run.summary.errored > 0 && (
                  <span className={styles.error}>⚠ {run.summary.errored}</span>
                )}
                <span className={styles.dur}>{formatDuration(run.summary.duration_ms)}</span>
              </div>
            )}
            {run.parentRunId && (
              <span className={styles.parent}>↩ from #{run.parentRunId.slice(0, 8)}</span>
            )}
          </div>
        </Link>
      ))}
      {hasMore && onLoadMore && (
        <button className={styles.loadMore} onClick={onLoadMore}>
          Load more
        </button>
      )}
    </div>
  );
}
